import { Button, Popover, Tooltip } from 'antd';
import { useState } from 'react';

import done from '../../../assets/Done, Check.svg';
import stopImage from '../../../assets/stopImage.svg';
import { SupplierI, tenderDataProps } from '../../../pages/TenderViewPage/types';
import { annualPriceForSupplier, formatSupplierPriceZAR } from '../../../utils/supplierPayloadPricing';
import {
    iconButton,
    NoData,
    Pricing,
    ScoreBase,
    ScoreBuilding,
    ScoreLeading,
    ScoreStrong
} from '../DesignPhaseComponents/SupplierCardEvaluate1.tsx/icons';
import { ScoreHoverPanelContent } from '../DesignPhaseComponents/SupplierCardEvaluate1.tsx/ScoreHoverPanelContent';
import { ViewSupplierDataModal } from '../DesignPhaseComponents/SupplierCardEvaluate1.tsx/ViewSupplierDataModal';

export const SupplierCardEvaluate3SU = ({
    item,
    setIsRejectIncumbentModal,
    setSelectedSupplier,
    setIsRejectModal,
    setTaskId,
    data,
    shortlistFunc,
    isLoadingShortList,
    index,
    status
}: {
    item: SupplierI;
    setIsRejectIncumbentModal: any;
    setSelectedSupplier: any;
    setIsRejectModal: any;
    setTaskId: any;
    data: tenderDataProps;
    shortlistFunc: any;
    isLoadingShortList: boolean;
    index: number;
    status?: string;
}) => {
    const [isSuppModal, setIsSuppModal] = useState<boolean>(false);

    const capabilityLevelRaw = item?.score?.avg?.capability_level;
    const capabilityKey = capabilityLevelRaw?.trim().toLowerCase();
    const capabilityStatIcon =
        capabilityKey === 'basic'
            ? ScoreBase
            : capabilityKey === 'building'
            ? ScoreBuilding
            : capabilityKey === 'strong'
            ? ScoreStrong
            : capabilityKey === 'leading'
            ? ScoreLeading
            : NoData;
    const capabilityScoreNum = item?.score?.avg?.capability_score;
    const capabilityStatSpan =
        capabilityKey === 'basic' ||
        capabilityKey === 'building' ||
        capabilityKey === 'strong' ||
        capabilityKey === 'leading'
            ? capabilityLevelRaw!.trim()
            : capabilityLevelRaw?.trim() || 'No data';

    const annualPrice = annualPriceForSupplier(item);

    const file_downloaded = true;

    return (
        <>
            <div className="supplier-card">
                <div className="supplier-card__index">{index + 1}</div>

                <div className="supplier-card__content">
                    <div className="supplier-card__header">
                        <div className="supplier-card__info">
                            <div className="supplier-card__badge-wrapper">
                                {item?.added_by_bayer && <div className="supplier-card__added">Added by buyer</div>}
                                {item.incumbent && <div className="supplier-card__badge">Incumbent Supplier</div>}
                            </div>
                            <div className="supplier-card__name">
                                <div className="title">{item.name}</div>
                                <div className="subtitle">{item?.trading_name}</div>
                            </div>
                        </div>

                        <div className="supplier-card__stats">
                            <div className="stat supplier-card__pricing-stat">
                                <div className="stat__value supplier-card__pricing-value">
                                    {annualPrice != null ? (
                                        <>
                                            <span className="supplier-card__pricing-icon">{Pricing}</span>
                                            <span className="supplier-card__pricing-amount">
                                                {formatSupplierPriceZAR(annualPrice)}
                                            </span>
                                            <span className="supplier-card__pricing-period">/year</span>
                                        </>
                                    ) : (
                                        <span className="supplier-card__pricing-empty">—</span>
                                    )}
                                </div>
                                <div className="stat__label supplier-card__pricing-label">Avg. Price</div>
                            </div>

                            <div className="divider" />

                            <div className="stat">
                                <div className="stat__value">
                                    {capabilityStatIcon}
                                    {capabilityScoreNum !== undefined && capabilityScoreNum !== null
                                        ? `${capabilityScoreNum}% `
                                        : ''}
                                    <span>{capabilityStatSpan}</span>
                                </div>
                                <div className="stat__label">Avg. Score</div>
                            </div>

                            <Popover
                                trigger="click"
                                placement="topRight"
                                destroyTooltipOnHide
                                overlayClassName="supplier-card-score-popover"
                                content={<ScoreHoverPanelContent item={item} supplierListPosition={index + 1} />}
                            >
                                <div
                                    className="icon-button icon-button--popover-trigger"
                                    role="button"
                                    tabIndex={0}
                                    aria-haspopup="dialog"
                                >
                                    <div className="icon-button__icon">{iconButton}</div>
                                </div>
                            </Popover>
                        </div>
                    </div>

                    <div className="supplier-card__footer">
                        <Button onClick={() => setIsSuppModal(true)}>Supplier Details</Button>

                        <div className="supplier-card__actions">
                            <div className="task-complete__title-row">
                                {item.status === 'rejected' ? (
                                    <div className="task-complete__title-row" style={{ margin: '0 12px 0 0' }}>
                                        <div className="task-complete__decline-active">
                                            <img src={stopImage} />
                                            Rejected
                                        </div>
                                    </div>
                                ) : status === 'completed' ? null : (
                                    <Tooltip
                                        title="To Reject or Shortlist the suppliers, you need download Supplier Profile Summary first!"
                                        overlayClassName={
                                            !file_downloaded ? 'custom-tooltip-disabled' : 'custom-tooltip'
                                        }
                                    >
                                        <div
                                            className={`task-complete__decline ${file_downloaded ? '' : 'disable'}`}
                                            onClick={() => {
                                                if (file_downloaded) {
                                                    setTaskId(item.id);
                                                    setSelectedSupplier(item);
                                                    if (item.incumbent) {
                                                        setIsRejectIncumbentModal(true);
                                                    } else {
                                                        setIsRejectModal(true);
                                                    }
                                                }
                                            }}
                                        >
                                            Reject
                                        </div>
                                    </Tooltip>
                                )}

                                {item.status === 'shortlisted' ? (
                                    <div className="task-complete__approved-active">
                                        <img src={done} />
                                        Awarded
                                    </div>
                                ) : status === 'completed' ? null : (
                                    <Tooltip
                                        title="To Reject or Shortlist the suppliers, you need download Supplier Profile Summary first!"
                                        overlayClassName={
                                            !file_downloaded ? 'custom-tooltip-disabled' : 'custom-tooltip'
                                        }
                                    >
                                        <div
                                            className={`task-complete__approved ${
                                                !file_downloaded ? 'disabled-blue-button' : ''
                                            }`}
                                            onClick={() => {
                                                if (isLoadingShortList) return;
                                                if (file_downloaded) {
                                                    shortlistFunc(item.id);
                                                }
                                            }}
                                        >
                                            Award
                                        </div>
                                    </Tooltip>
                                )}
                            </div>
                        </div>
                    </div>

                    {item.status === 'rejected' &&
                        (item?.comments?.su_rejected_comment || item?.comments?.su_rejected_category_name) && (
                            <div className="supplier-card__rejection-reason">
                                <div className="supplier-card__rejection-reason-label">Reason for Rejection</div>
                                <div className="supplier-card__rejection-reason-text">
                                    {item.comments.su_rejected_comment
                                        ? item.comments.su_rejected_comment
                                        : item.comments.su_rejected_category_name}
                                </div>
                            </div>
                        )}
                </div>
            </div>
            {isSuppModal && (
                <ViewSupplierDataModal
                    openModal={isSuppModal}
                    setOpen={setIsSuppModal}
                    item={item}
                    supplierListPosition={index + 1}
                />
            )}
        </>
    );
};
